module.exports = __webpack_public_path__ + "static/media/Tick.0e9ab0f0.svg";